/* Raised Ready Co. — motion layer (Cooper): scroll reveals + header state */
(function () {
  if (window.Shopify && Shopify.designMode) return;

  function init() {
    /* Header shadow on scroll */
    var onScroll = function () {
      document.body.classList.toggle('rr-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Scroll reveals */
    var main = document.getElementById('MainContent');
    if (!main || !('IntersectionObserver' in window)) return;

    var selector = [
      '#MainContent .shopify-section:not(:first-child) h2',
      '#MainContent .shopify-section:not(:first-child) h3',
      '#MainContent product-card',
      '#MainContent .product-card',
      '#MainContent [class*="product-card"]',
      '#MainContent .shopify-section:not(:first-child) picture'
    ].join(',');

    var seen = new Set();
    var targets = [];
    document.querySelectorAll(selector).forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      targets.push(el);
    });
    targets = targets.slice(0, 80);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rr-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    targets.forEach(function (el, i) {
      el.classList.add('rr-reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
